import { useAuth } from '@clerk/nextjs';
import axios from 'axios';
import React from 'react';

function SignalTargetingInterceptor() {
  const { getToken, isSignedIn } = useAuth();

  React.useEffect(() => {
    if (!isSignedIn) return;

    // Listens to all requests and adds the token to the header
    // TODO - call interceptors.eject to remove the interceptor - MUST
    const signalTargetingInterceptor = axios.interceptors.request.use(
      async function (config) {
        if (config.baseURL?.endsWith('signals')) {
          config.url = `targeting/${config.url}`;
        }
        return config;
      },
      function (error: any) {
        // Do something with request error
        return Promise.reject(error);
      },
    );

    return () => {
      // Ejects the interceptor
      axios.interceptors.request.eject(signalTargetingInterceptor);
    };
  }, [isSignedIn, getToken]);

  return null;
}

export { SignalTargetingInterceptor };
